const formatToUsd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'  
})

export default function(price) {
  return formatToUsd.format(price).replace(/\.00/, ""); // Convert $250.00 to $250
}